import RowItemListHandleOldLetters from './RowItemListHandleOldLetters.jsx';

export {
  RowItemListHandleOldLetters
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/datatable/list/index.js